// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__mqFbG","productsWithoutGuid":"styles_productsWithoutGuid__T3rLa"};